import { api } from "shared/config/api/api";

import { PROMO_V1_URL } from "./promoUrl";

import type {
  ParticipantsPage,
  WinnersPage,
  GetListRaffleParticipantsParams,
} from "../model/types";

// Доступно только создателю розыгрыша; остальным бэк отвечает 403.
export const raffleOrganizerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRaffleParticipantsPage: builder.query<
      ParticipantsPage,
      GetListRaffleParticipantsParams
    >({
      query: ({ raffleId, page = 1, perPage = 10 }) => ({
        url: `${PROMO_V1_URL}/wheel-raffles/${raffleId}/participants`,
        params: { page, per_page: perPage },
      }),
      providesTags: ["WheelRaffle"],
    }),
    getRaffleWinnersPage: builder.query<
      WinnersPage,
      GetListRaffleParticipantsParams
    >({
      query: ({ raffleId, page = 1, perPage = 10 }) => ({
        url: `${PROMO_V1_URL}/wheel-raffles/${raffleId}/winners`,
        params: { page, per_page: perPage },
      }),
      providesTags: ["WheelRaffle"],
    }),
  }),
});

export const {
  useGetRaffleParticipantsPageQuery,
  useGetRaffleWinnersPageQuery,
} = raffleOrganizerApi;
